import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-383e5c42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row g-0" }
const _hoisted_2 = { class: "col d-flex justify-content-center" }
const _hoisted_3 = { class: "row g-0 eFj-list-content" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "eFj-list-card" }
const _hoisted_6 = { class: "row g-0" }
const _hoisted_7 = { class: "col-2 eFj-list-card-image" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "col-7 eFj-list-card-text" }
const _hoisted_10 = { class: "col-3" }
const _hoisted_11 = { class: "row g-0 pr-1" }
const _hoisted_12 = { class: "row g-0 pr-1" }
const _hoisted_13 = { class: "col eFj-list-card-gueltig" }
const _hoisted_14 = { class: "row g-0" }
const _hoisted_15 = { class: "col eFj-list-card-gueltig" }
const _hoisted_16 = { class: "row g-0 eFj-product-detail-text" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, null, -1))
const _hoisted_18 = { class: "col-7" }
const _hoisted_19 = { class: "row g-0 eFj-product-detail-text-content" }
const _hoisted_20 = { class: "col" }
const _hoisted_21 = { class: "detail-text-produktnr" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row g-0 eFj-product-detail-text-content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col detail-height" }, [
    /*#__PURE__*/_createElementVNode("span", null, " ")
  ])
], -1))
const _hoisted_23 = {
  key: 0,
  class: "row g-0 eFj-product-detail-text-content"
}
const _hoisted_24 = { class: "col" }
const _hoisted_25 = {
  key: 1,
  class: "row g-0 eFj-product-detail-text-content"
}
const _hoisted_26 = { class: "col" }
const _hoisted_27 = {
  key: 2,
  class: "row g-0 eFj-product-detail-text-content"
}
const _hoisted_28 = { class: "col" }
const _hoisted_29 = {
  key: 3,
  class: "row g-0 eFj-product-detail-text-content"
}
const _hoisted_30 = { class: "col" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, null, -1))
const _hoisted_32 = { class: "row g-0 product-detail-info" }
const _hoisted_33 = { class: "col" }
const _hoisted_34 = {
  key: 0,
  class: "row g-0 efj-list-content-footer"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col d-flex justify-content-center align-content-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "eFj-paging-image",
    src: "img/icons/paging_selected.svg"
  })
], -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = {
  key: 1,
  class: "row g-0 product-detail-info"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1))
const _hoisted_39 = [
  _hoisted_38
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_show_qr_code = _resolveComponent("show-qr-code")!

  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => ($setup.onClosed && $setup.onClosed(...args)), ["prevent"])),
    class: "product-detail-content"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("img", {
                    class: "eFj-image",
                    src: $setup.getImagePath($setup.dynamic.row)
                  }, null, 8, _hoisted_8)
                ]),
                _createElementVNode("div", _hoisted_9, _toDisplayString($setup.dynamic.row.cell.content.title), 1),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["col eFj-list-card-status", $setup.dynamic.row.cell.image.imageState])
                    }, _toDisplayString($setup.dynamic.row.cell.additional.text), 3)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, _toDisplayString($setup.dynamic.row.cell.additional.gueltigVon), 1)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, _toDisplayString($setup.dynamic.row.cell.additional.gueltigBis), 1)
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _hoisted_17,
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("span", _hoisted_21, _toDisplayString($setup.detailInfo.result.personProduktNummer), 1)
          ])
        ]),
        _hoisted_22,
        ($setup.detailInfo.result.nachname)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, _toDisplayString($setup.detailInfo.result.vorname) + "  " + _toDisplayString($setup.detailInfo.result.nachname), 1)
            ]))
          : _createCommentVNode("", true),
        ($setup.detailInfo.result.strasse != '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, _toDisplayString($setup.detailInfo.result.strasse) + "  " + _toDisplayString($setup.detailInfo.result.strassenummer), 1)
            ]))
          : _createCommentVNode("", true),
        ($setup.detailInfo.result.plz)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, _toDisplayString($setup.detailInfo.result.land) + "  " + _toDisplayString($setup.detailInfo.result.plz) + "  " + _toDisplayString($setup.detailInfo.result.ort), 1)
            ]))
          : _createCommentVNode("", true),
        ($setup.dynamic.row.cell.content.groundNumber && $setup.dynamic.row.cell.content.groundNumber.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, _toDisplayString($setup.dynamic.row.cell.content.groundNumber) + "  " + _toDisplayString($setup.dynamic.row.cell.content.groundName) + "  ", 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_31
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("div", _hoisted_33, [
        _createVNode(_component_show_qr_code, _normalizeProps(_guardReactiveProps($setup.qrc)), null, 16)
      ])
    ]),
    (($setup.dynamic.grid.pages ?? 1) > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_36))
      : (_openBlock(), _createElementBlock("div", _hoisted_37, _hoisted_39))
  ]))
}